module.exports = __webpack_public_path__ + "static/media/phone-1.8fb0a9cb.svg";